// extracted by mini-css-extract-plugin
module.exports = {"icon":"Button_icon__uy-69","badge":"Button_badge__3fXV6","status":"Button_status__84hFh"};